'use client';

export const Menu = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M3.96085 24.2349C3.68862 24.2349 3.46048 24.1424 3.27644 23.9574C3.09215 23.7723 3 23.5429 3 23.2691C3 22.9954 3.09215 22.7677 3.27644 22.5862C3.46048 22.4045 3.68862 22.3136 3.96085 22.3136H28.0391C28.3114 22.3136 28.5395 22.4061 28.7236 22.5912C28.9079 22.7763 29 23.0057 29 23.2794C29 23.5532 28.9079 23.781 28.7236 23.9627C28.5395 24.1442 28.3114 24.2349 28.0391 24.2349H3.96085ZM3.96085 16.5783C3.68862 16.5783 3.46048 16.4857 3.27644 16.3004C3.09215 16.1153 3 15.886 3 15.6125C3 15.3387 3.09215 15.111 3.27644 14.9292C3.46048 14.7475 3.68862 14.6566 3.96085 14.6566H28.0391C28.3114 14.6566 28.5395 14.7493 28.7236 14.9346C28.9079 15.1196 29 15.3489 29 15.6224C29 15.8962 28.9079 16.124 28.7236 16.3057C28.5395 16.4875 28.3114 16.5783 28.0391 16.5783H3.96085ZM3.96085 8.92132C3.68862 8.92132 3.46048 8.82879 3.27644 8.64373C3.09215 8.45868 3 8.22926 3 7.9555C3 7.68173 3.09215 7.45398 3.27644 7.27224C3.46048 7.09074 3.68862 7 3.96085 7H28.0391C28.3114 7 28.5395 7.09253 28.7236 7.27759C28.9079 7.46265 29 7.69206 29 7.96582C29 8.23959 28.9079 8.46722 28.7236 8.64871C28.5395 8.83045 28.3114 8.92132 28.0391 8.92132H3.96085Z"
				fill="currentColor"
			/>
		</svg>
	);
};
